function getSample (sampleId) {
  if (!this.samples) return
  const sample = this.samples[sampleId]
  if (!sample) return
  return sample
}

export default getSample